/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {Text, View, StyleProp, ViewStyle} from 'react-native';

interface Props {
  checked: boolean;
  setChecked: Function;
  linkUrl?: {label: string, value: string};
  text?: string;
  style?: StyleProp<ViewStyle>;
}
export const CheckBoxWithHyperlink = ({checked, setChecked, linkUrl = {value: "https://tools.assurancesaro.mg/privacy.html", label: 'politique de Confidentialité.'}, text = `En soummettant ce formulaire, j'accepte que mes informations soient utilisées uniquement dans la cadre de la&nbsp;`, style}: Props) => {
  const [isSelected, setSelected] = useState<boolean>(false);

  const handleChange = (event: any) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
  }, [isSelected]);

  return (
    <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
      <View
        style={{
          marginLeft: 10,
          marginRight: 10,
          flexDirection: 'row',
        }}>
        <input
          type="checkbox"
          style={{
            alignSelf: 'center',
          }}
          checked={checked}
          onChange={handleChange}
        />

        <Text>
          {text}
          <a href={linkUrl.value}>{linkUrl.label}</a>
        </Text>
      </View>
    </View>
  );
};
